import { useContext } from 'react';
import { useValidateDraftCondition } from '../../hooks/useValidateDraftCondition';
import { useViewerActions } from '../../hooks/useViewerActions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { AddIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerAddFilterButton = props => {
  const {
    parentGroupKeyPath,
    filterFamily
  } = props;
  const {
    draftCondition,
    isInEditMode,
    props: {
      uiMessages: {
        addFilterButtonLabel
      }
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    onAddFilter
  } = useViewerActions();
  const {
    validateDraftCondition
  } = useValidateDraftCondition();
  if (!isInEditMode) {
    return null;
  }
  const isEditorOpen = Boolean(draftCondition);
  const onAddFilterClicked = () => {
    if (isEditorOpen && draftCondition) {
      validateDraftCondition();
    }
    onAddFilter(parentGroupKeyPath, filterFamily);
  };
  return /*#__PURE__*/_jsx(Button, {
    "data-selenium-info": `And-${parentGroupKeyPath.join('__')}`,
    "data-selenium-test": "fr-viewer-add-filter-btn",
    onClick: onAddFilterClicked,
    size: "xs",
    use: "tertiary-light",
    responsive: false,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "100",
      children: [/*#__PURE__*/_jsx(AddIcon, {}), addFilterButtonLabel || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.filtersViewer.addFilter"
      })]
    })
  });
};
export default ViewerAddFilterButton;